import React, { useContext, useEffect, useState } from "react";
import DynamicTable from "../../../../layout/DynamicTable/DynamicTable";
import { action, API, controller } from "../../../../api/api";
import Header from "./Header";
import { formatDate, useFormatPrice } from "hooks";
import { IconButton, Tooltip } from "@mui/material";
import { VisibilityRounded } from "@mui/icons-material";
import { Dialog } from "layout";
import ViewDetails from "./ViewDetails/ViewDetails";
import { AppContext } from "App";

const PrintLabelHistory = () => {
  const formatPrice = useFormatPrice();
  const { setLoader } = useContext(AppContext);
  const [showDetails, setShowDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState({});
  const [tblData, setTblData] = useState([]);
  const [labels, setLabels] = useState([]);

  const handleView = (id) => {
    if (id) {
      setLoader(true);
      API(controller.PrintLabel + action.GetById).getById(id, (res) => {
        if (res.status === 200 && res.result?.id) {
          setShowDetails(true);
          setViewDetails({ ...res.result });
        }
        setLoader(false);
      });
    }
  };

  useEffect(() => {
    setTblData([
      ...labels.map((j) => ({
        id: j.id,
        label: (
          <div className="flex flex-col">
            <div className="flex gap-2 font-medium">
              <span>Id: {j.id} </span> |{" "}
              <span className="text-[14px] uppercase">{j.printType}</span>
            </div>

            <span className="text-[12px]"> {formatDate(j.createDate)}</span>
          </div>
        ),
        totalItemAndLabel: (
          <div className="flex flex-col text-[13px] uppercase">
            <div className="flex gap-1">
              <span>Item : </span>
              <span className="font-bold">{j.totalItems}</span>
            </div>
            <div className="flex gap-1">
              <span>Label : </span>
              <span className="font-bold">{j.totalLabel}</span>
            </div>
          </div>
        ),
        print: (
          <div className="grid grid-cols-2 gap-1 text-[13px] uppercase">
            <div className="flex gap-1">
              <span>Outlet Name :</span>
              <span className="font-bold">{j.showOutlet.toString()}</span>
            </div>
            <div className="flex gap-1">
              <span>Product Title :</span>
              <span className="font-bold">{j.showProdTitle.toString()}</span>
            </div>
            <div className="flex gap-1">
              <span>Sku Code :</span>
              <span className="font-bold">{j.showSku.toString()}</span>
            </div>
            <div className="flex gap-1">
              <span>Retail Price :</span>
              <span className="font-bold">{formatPrice(j.showRtlPrice)}</span>
            </div>
          </div>
        ),
      })),
    ]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [labels]);

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setLabels}
        endpointKey={controller.PrintLabel + action.GetAllByOrg}
        exportEndpoint={controller.PrintLabel + action.ExportLabels}
        enableDateRange={true}
        enableExport={true}
        ActionComp={(param) => (
          <>
            <Tooltip title="View Details">
              <IconButton
                onClick={() => handleView(param.id)}
                size="small"
                color="primary"
              >
                <VisibilityRounded className="!text-[20px]" />
              </IconButton>
            </Tooltip>
          </>
        )}
        HeaderComp={() => <Header />}
        headers={[
          { id: "actions", label: "Actions" },
          { id: "label", label: "Label" },
          { id: "totalItemAndLabel", label: "Total Item and Label" },
          { id: "print", label: "Print" },
        ]}
      />

      {/* View Product */}
      {showDetails && (
        <Dialog show={showDetails} onClose={false} maxWidth="md">
          <ViewDetails
            {...{ setShowForm: setShowDetails, values: viewDetails }}
          />
        </Dialog>
      )}
    </>
  );
};

export default PrintLabelHistory;
